module.exports = __webpack_public_path__ + "img/signal_cellular_no_sim.34251407.svg";